module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/data/fp-commerce/shared-live/tmp/shop/node_modules/babel-loader/lib/index.js!/data/fp-commerce/shared-live/tmp/shop/client/generated/translation-1-de_DE.js"));
    });
  });
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/promise-loader?global!./generated/translation-1-de_DE.js
 ** module id = 85
 ** module chunks = 20 21
 **/